<div id="card-info-1" class="container-cards">
  <div id="card-info-2"
    class="container-benfeficiare-request"
    *ngFor="let beneficiary of beneficiaries"
  >
    <div id="card-info-3" class="box-title-beneficiarie d-flex justify-content-between">
      <span id="card-info-4" class="copec-rg-16">{{ beneficiary.name }}</span>
    </div>
    <div id="card-info-5" class="box-beneficiare-date">
      <div id="card-info-6" class="column-box">
        <span id="spam-info-1"> Rut </span>
        <span id="spam-info-2"> Fecha de nacimiento </span>
        <span id="spam-info-3"> Parentesco </span>
        <span id="spam-info-4"> Sistema de Salud </span>
      </div>
      <div id="card-info-7" class="column-box">
        <span id="spam-info-6"> {{ beneficiary.rut }} </span>
        <span id="spam-info-7"> {{ beneficiary.birthdate | date: "dd-MM-yyyy" }} </span>
        <span id="spam-info-8"> {{ beneficiary.relationship }} </span>
        <span id="spam-info-9"> {{ beneficiary.healthCareSystem }} </span>
      </div>
    </div>
  </div>
</div>
